module.exports = __webpack_public_path__ + "img/contatc-page-bg.36fb9cdf.jpeg";